var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var SystemError = /** @class */ (function (_super) {
    __extends(SystemError, _super);
    function SystemError(code, message, subErrors) {
        var _this = _super.call(this, message) || this;
        _this.code = code;
        _this.message = message;
        _this.subErrors = subErrors;
        return _this;
    }
    Object.defineProperty(SystemError.prototype, "code", {
        get: function () {
            return this._code;
        },
        set: function (value) {
            this._code = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemError.prototype, "subErrors", {
        get: function () {
            return this._subErrors;
        },
        set: function (value) {
            this._subErrors = value;
        },
        enumerable: true,
        configurable: true
    });
    return SystemError;
}(Error));
export { SystemError };



// WEBPACK FOOTER //
// ./src/app/shared/models/SystemError.ts.pre-build-optimizer.js